import {IOption} from "../interface";

const AUSWHAL: IOption[] = [
    {
        name: 'Stabgeländer',
        value: 'stabgelander'
    }
];

const BALKON: IOption[] = [
    {
        name: 'I-Form',
        value: 'i-form'
    },
    {
        name: 'L-Form',
        value: 'l-form'
    },
    {
        name: 'U-Form',
        value: 'u-form'
    }
];

const FULLUNG: IOption[] = [
    {
        name: 'mit exakter Bohrung',
        value: 'mit-exakter-bohrung'
    },
    {
        name: 'mit Stabhaltern',
        value: 'mit-stabhaltern'
    },
    {
        name: 'geschweißte Ausführung',
        value: 'geschweibte-ausfuhr',
    }
]

const MONTAGEART: IOption[] = [
    {
        name: 'Aufgesetzt',
        value: 'aufgesetzt'
    },
    {
        name: 'Vorgesetzt',
        value: 'vorgesetzt'
    }
];

const WANDABSTAND: IOption[] = [
    {
        name: '30 mm',
        value: '30-mm'
    },
    {
        name: '50 mm',
        value: '50-mm'
    },
    {
        name: '100 mm',
        value: '100-mm'
    }
];

export {AUSWHAL, BALKON, FULLUNG, MONTAGEART, WANDABSTAND};